export const groupMoc = {
    title: 'Vá em grupo e pague mais barato!',
    text: 'Se você deseja ir em 4 pessoas ou mais, acione nosso time, temos uma oferta exclusiva para vocês.',
    buttonText: 'Quero mais informações sobre o Grupo.',
}
